<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-snackbar
            v-model="snackbar"
            top
            color="#0080aa"
    >
      {{txt}}
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    //
  }),
  computed: {
    snackbar: {
      get: function(){
        return this.$store.state.show;
      },
      set: function(v){
        this.$store.state.show = v;
      }
    },
    txt: function(){
      return this.$store.state.txt
    }
  }
};
</script>

<style>
  .theme--light.v-input {
    color: #e5e5e5
  }
  .v-text-field--outlined {
    color: #e5e5e5 !important
  }
  .v-application .elevation-5 {
    -webkit-box-shadow: 0px 3px 5px -1px rgba(239, 239, 239, 0.2), 0px 5px 8px 0px rgba(239, 239, 239, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12) !important;
    box-shadow: 0px 3px 5px -1px rgba(239, 239, 239, 0.2), 0px 5px 8px 0px rgba(239, 239, 239, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12) !important;
  }

  .v-select__selection.v-select__selection--comma {
    font-size: 0.8rem!important;
  }
  .v-input--radio-group__input {
    justify-content: space-around;
  }
</style>
